export default __webpack_public_path__ + "static/media/Extras_TiposDeChocolate.ae285033.jpg";